import React, { useState, useEffect } from "react";
import { useNavigate, NavLink } from 'react-router-dom';
import "./Navbar.css";
import Tooltip from '../tooltip/Tooltip';

export default function Navbar({ avatar, onFirstClick, onSecondClick, isClicked , isMode}) {
    const [userName, setUserName] = useState("Utente");

    const navigate = useNavigate();
    // Stato per il sottomenu aperto (identificatore del menu)
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const [tooltip, setTooltip] = useState('');
    // Funzione per gestire l'apertura del sottomenu
    const handleMenuClick = (index) => {
        setOpenSubmenu(openSubmenu === index ? null : index); // Se il menu è già aperto, lo chiude, altrimenti lo apre
    };
    // Funzione per gestire la visualizzazione della tooltip
    const handleMouseEnter = (text) => {
        setTooltip(text);
    };
    // Funzione per nascondere la tooltip
    const handleMouseLeave = () => {
        setTooltip('');
    };
    const handleLogout = () => {
        localStorage.removeItem('token'); // Rimuovi il token
        localStorage.removeItem('id_user');
        localStorage.removeItem('username');
        localStorage.removeItem('avatar');
        navigate('/login'); // Reindirizza alla pagina di login
    };

    useEffect(() => {
        // Recupera il nome utente dal localStorage
        setUserName(localStorage.getItem("name"));
    }, []);


  	return (
        <nav className="layout-navbar-fixed layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme">
            <div className="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
                <a className="nav-item nav-link px-0 me-xl-6" onClick={onFirstClick}>
                    <i className="bx bx-menu bx-md"></i>
                </a>
            </div>
            <div className="navbar-nav-right d-flex align-items-center">
                {/* Search
                <div className="navbar-nav align-items-center">
                    <div className="nav-item navbar-search-wrapper mb-0">
                        <a className="nav-item nav-link search-toggler px-0" href="">
                            <i className="bx bx-search bx-md"></i>
                            <span className="d-none d-md-inline-block text-muted fw-normal ms-4">Cerca</span>
                        </a>
                    </div>
                </div>
                Search */}
                <ul className="navbar-nav flex-row align-items-center ms-auto">
                    {/* Style */}
                    <li className="nav-item dropdown-style-switcher dropdown me-2 me-xl-0">
                        {tooltip && <Tooltip value={tooltip} />}
                        <a className={`nav-link dropdown-toggle hide-arrow ${openSubmenu === 0 ? "show" : ""}`} onClick={() => handleMenuClick(0)}
                            onMouseEnter={() => handleMouseEnter('Modalità')} onMouseLeave={handleMouseLeave}>
                            <i className="bx bx-md bx-sun"></i>
                        </a>
                        <ul className={`dropdown-menu dropdown-menu-end dropdown-styles ${openSubmenu === 0 ? "show" : ""}`} data-bs-popper="static">
                            <li>
                                <a className={`dropdown-item ${isMode === "light" ? "active" : ""}`} onClick={() => {onSecondClick('light');handleMenuClick(null)}}>
                                    <span><i className="bx bx-sun bx-md me-3"></i>Light</span>
                                </a>
                            </li>
                            <li>
                                <a className={`dropdown-item ${isMode === "dark" ? "active" : ""}`} onClick={() => {onSecondClick('dark');handleMenuClick(null)}}>
                                    <span><i className="bx bx-moon bx-md me-3"></i>Dark</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    {/* /Style */}
                    {/* User */}
                    <li className="nav-item navbar-dropdown dropdown-user dropdown">
                        <a className={`nav-link dropdown-toggle hide-arrow p-0 ${openSubmenu === 1 ? "show" : ""}`} onClick={() => handleMenuClick(1)}>
                            <div className="avatar">
                                <img src={avatar} className="w-px-40 h-auto rounded-circle" />
                            </div>
                        </a>
                        <ul className={`dropdown-menu dropdown-menu-end ${openSubmenu ===  1 ? "show" : ""}`} data-bs-popper="static">
                            <li>
                                <a className="dropdown-item">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <h6 className="mb-0 text-center">{userName}</h6>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li><div className="dropdown-divider my-1"></div></li>
                            <li>
                                <NavLink to="/profile-user" onClick={() => handleMenuClick(null)} className="dropdown-item">
                                    <i className="bx bx-user bx-md me-3"></i><span>Mio Profilo</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/settings-user" onClick={() => handleMenuClick(null)} className="dropdown-item">
                                    <i className="bx bx-cog bx-md me-3"></i><span>Settings</span>
                                </NavLink>
                            </li>
                            <li>
                                <a className="dropdown-item" href="#">
                                    <i className="bx bx-help-circle bx-md me-3"></i><span>FAQ</span>
                                </a>
                            </li>
                            <li><div className="dropdown-divider my-1"></div></li>
                            <li>
                                <a className="dropdown-item" onClick={handleLogout}>
                                    <i className="bx bx-power-off bx-md me-3"></i><span>Log Out</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    {/* /User */}
                </ul>
            </div>
        </nav>
	);
}